"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgiftcard = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 63 54",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgiftcard` : '') + (description ? ` desc-brandedgiftcard` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgiftcard"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgiftcard"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.69 18.56c-.3-.95.28-1.97 1.28-2.28L50.01 1.9c1-.3 2.05.22 2.34 1.17l9.47 30.98c.3.95-.28 1.97-1.28 2.28L13.5 50.7c-1 .3-2.05-.22-2.34-1.17L1.69 18.56Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.42 30.54 3.05 23l50.3-16.13 2.37 7.05-50.3 16.62Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 22.65c0-.91.83-1.65 1.86-1.65h48.28c1.03 0 1.86.74 1.86 1.65v29.7c0 .91-.83 1.65-1.86 1.65H12.86c-1.03 0-1.86-.74-1.86-1.65v-29.7Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.69 54h48.6c.95 0 1.71-.74 1.71-1.65v-29.7c0-.91-.77-1.65-1.7-1.65H55C43.7 35.34 29.02 46.75 11.5 53.5c0 0 .5.5 1.19.5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 39v-4h52v4H11Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 39h26v-4H41.65A118 118 0 0 1 37 39Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 21h4v33h-4V21Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.25 28.1c1.9-1.7 5.34-1.4 7.67.69 1.66 1.48 2.4 5.27 2.7 7.35l.16.13.17-.13c.3-2.08 1.04-5.86 2.7-7.35 2.33-2.08 5.76-2.4 7.67-.68 1.91 1.72 1.58 4.8-.75 6.88-1.4 1.26-4.62 1.93-7 2.27l3.64 3.04-2.6 2.2-3.83-4.9-5.16 7.4-3.3-3 5.67-4.73c-2.37-.34-5.6-1-7-2.25-2.32-2.1-2.66-5.18-.75-6.89v-.01Zm19.37 4.72c1.19-1.06 1.35-2.64.38-3.51-.98-.88-2.73-.72-3.92.34-1.2 1.07-1.47 4.49-1.47 4.49s3.8-.25 5-1.32Zm-12.66 1.31s-.28-3.42-1.47-4.48c-1.19-1.07-2.94-1.22-3.92-.35s-.8 2.45.39 3.51c1.2 1.07 5 1.32 5 1.32Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 47.04V54h4v-9.3c-1.32.91-2.65 1.5-4 2.34Z",
    fill: "#CC0058"
  }));
};
var _default = exports.default = brandedgiftcard;